export const NOTIFY = 'NOTIFY'
export const REMOVE_NOTIFICATION = 'REMOVE_NOTIFICATION'

let id = 1

const generateId = () => id++

export const notify = (type, message, options = {}) => ({
  type: NOTIFY,
  payload: {
    type,
    message,
    sticky: false,
    timeout: 3000,
    dismissable: true,
    id: generateId(),
    onClick: () => {},
    onClose: () => {},
    ...options
  }
})

export const removeNotification = id => ({
  type: REMOVE_NOTIFICATION,
  payload: {
    id
  }
})
